import { normalizeAssetLookupKey } from './bookingAssetThumbnailCache';
import { assetRecordPrimaryId } from './assetRecordPrimaryId';
import { assetRecordShortDisplayId } from './assetShortId';

const snapshotByKey = new Map<string, Record<string, unknown>>();

function lookupKeysForAssetId(assetId: string): string[] {
  const trimmed = assetId.trim();
  if (!trimmed) {
    return [];
  }
  return [trimmed.toLowerCase(), normalizeAssetLookupKey(trimmed)];
}

/** Remember a search/list row so asset detail can keep its images after GET /assets/:id. */
export function rememberBrowseAssetListSnapshot(asset: Record<string, unknown>): void {
  const id = assetRecordPrimaryId(asset);
  if (!id) {
    return;
  }
  for (const key of lookupKeysForAssetId(id)) {
    snapshotByKey.set(key, asset);
  }
  const short = assetRecordShortDisplayId(asset);
  if (short) {
    snapshotByKey.set(short, asset);
  }
}

export function browseAssetListSnapshotForId(assetId: string): Record<string, unknown> | null {
  for (const key of lookupKeysForAssetId(assetId)) {
    const hit = snapshotByKey.get(key);
    if (hit) {
      return hit;
    }
  }
  return null;
}

/** Clears the in-memory store (tests only). */
export function resetBrowseAssetListSnapshotForTests(): void {
  snapshotByKey.clear();
}
